import { useParams } from 'react-router-dom'

import { AsyncBlock } from '../components/AsyncBlock'
import { ProjectHeading } from '../components/ProjectHeading'
import { api, type Communication } from '../lib/api'
import { fmtDate, humanize } from '../lib/format'
import { useAsync } from '../lib/useAsync'

function MessageCard({ message }: { message: Communication }): JSX.Element {
  return (
    <article className="card message-card">
      <div className="message-head">
        <h3>{message.subject}</h3>
        <span className="message-date">{fmtDate(message.sent_at)}</span>
      </div>
      <span className="message-type">{humanize(message.comm_type)}</span>
      <p className="message-body">{message.body}</p>
    </article>
  )
}

export function MessagesPage(): JSX.Element {
  const { projectId = '' } = useParams()
  // Communications are profile-scoped (not project-scoped) on the Worker;
  // the portal shows the full sent history regardless of which project tab
  // the client opened it from.
  const state = useAsync(() => api.communications(), 'communications')
  return (
    <div className="page">
      <ProjectHeading projectId={projectId} title="Messages" />
      <AsyncBlock
        state={state}
        isEmpty={(d) => d.communications.length === 0}
        emptyText="No messages from Heritage yet."
      >
        {(d) => (
          <div className="card-list">
            {d.communications.map((m) => (
              <MessageCard key={m.id} message={m} />
            ))}
          </div>
        )}
      </AsyncBlock>
    </div>
  )
}
